import React from 'react';
import Modal from 'contexts/ModalContext/Modal';
import styled from 'styled-components';

function InterviewMasterClassBasicIntroductionModal() {
  return (
    <Modal title='강의 소개' maxWidth={420}>
      <StyledContainer>
        전략컨설팅에 대해 처음 알게 된 순간부터 곧 면접을 앞둔 시점까지 셀프 학습에 필요한 모든 정보와 학습
        방법을 제공하는 강의입니다.
        <br /> 전략컨설팅의 정의부터 최근 시즌 합격자의 Mock 인터뷰 영상까지 MBB 각 펌 출신 컨설턴트들이 한데
        모여 만든 풀 패키지 강의를 경험해 보세요.
      </StyledContainer>
    </Modal>
  );
}

const StyledContainer = styled.p`
  font-size: 15px;
  font-weight: 400;
  line-height: 1.666;
  color: #555;
  margin: 0;
  word-break: keep-all;
`;

export default InterviewMasterClassBasicIntroductionModal;
